import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { INSIGHTS } from '../data/insights';

const formatDate = (iso) => new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

export const InsightsSection = () => {
  return (
    <section className="py-24 bg-slate-50" data-testid="capital-insights">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4 uppercase tracking-wide">
            Capital <span className="text-emerald-600">Insights</span>
          </h2>
          <p className="text-lg text-slate-600">
            Perspectives on corporate finance, debt markets, working capital, real estate finance and India's evolving lending environment
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {INSIGHTS.slice(0, 3).map((a) => (
            <Link
              key={a.slug}
              to={`/insights/${a.slug}`}
              className="group bg-white rounded-xl border border-slate-200 hover:border-emerald-500 hover:shadow-[0_4px_16px_rgba(15,23,42,0.08)] transition-all duration-300 p-8 flex flex-col"
              data-testid={`insight-card-${a.slug}`}
            >
              <div className="flex items-center gap-3 text-xs mb-4">
                <span className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full font-semibold">{a.category}</span>
                <span className="text-slate-400">{formatDate(a.date)}</span>
              </div>
              <h3 className="text-lg font-bold text-slate-900 leading-snug group-hover:text-emerald-700 transition-colors">{a.title}</h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{a.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-emerald-700 font-semibold text-sm group-hover:gap-2.5 transition-all">
                Read More <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
